/* import __COLOCATED_TEMPLATE__ from './error-conversation-is-restricted.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();